import React, { useEffect, useState } from "react";
import "./RecommendedPage.scss"
import arrow from "../../../assets/arrow-black.svg"
import search from "../../../assets/search-v2.svg"
import filter from "../../../assets/filter.svg"
import popular from "../../../assets/filters/popular.svg"
import rate from "../../../assets/filters/rated.svg"
import highest from "../../../assets/filters/more.svg"
import lowest from "../../../assets/filters/less.svg"
import redo from "../../../assets/redo.svg"
import { useHistory } from "react-router";
import CategoryLayoutList from "../../../components/CategoryLayout/CategoryLayoutList";
import FilterComponent from "../../../components/FilterComponent/FilterComponent";
import LayoutTemplate from "../../../components/layouts/LayoutTemplate";
import Pagination from "../../../components/Pagination/Pagination";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../utilities/helper";
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import { getFilteredData } from "../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import close from "../../../assets/close.svg"
import { getAllData } from "../../../../../../../../redux/resturantWidgetSlice";

const getData = async () => {
    const result = await getAllData();

    const allItems = Array.isArray(result?.data?.Items) ? result.data.Items : [];
    const allCategories = Array.isArray(result?.data?.Categories) ? result.data.Categories : [];

    const categories = allCategories.filter(
        (category) => !category.MetaData?.ShowAsOffer
    );

    const itemIDs = categories.flatMap(
        (category) => category.MenuEntities?.map(entity => entity.ID) || []
    );

    const items = allItems.filter(item =>
        itemIDs.includes(item.MenuItemID)
    );

    return items;
};

const RecommendedPage = () => {
    const [data, setData] = useState([])
    const [totalItems, setTotalItems] = useState(data.length);
    const [itemsData, setItemsData] = useState(data);
    const [menuData, setMenuData] = useState(itemsData?.slice(0, 12))
    const [allCategories, setAllCategories] = useState([])
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
        setIsLoading(true)
        const fetchData = async () => {
            const items = await getData();
            setData(items);
            setItemsData(items)
            setMenuData(items?.slice(0, 12))
            setTotalItems(items?.length)
            setIsLoading(false)
        };

        fetchData();
    }, [])
    useEffect(() => {
        getAllData().then((result) => {
            setAllCategories(result?.data?.Categories);
        });
    }, []);
    let categories = allCategories?.filter(
        (category) => !category.MetaData?.ShowAsOffer
    );
    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const sortList = [
        {
            label: "Most Popular",
            icon: popular,
            value: "popular"
        },
        {
            label: "Highest Rated",
            icon: rate,
            value: "rated",
        }, {
            label: "Price: Low to High",
            icon: highest,
            value: "price-asc",
        }, {
            label: "Price: High to Low",
            icon: lowest,
            value: "price-desc",
        },
    ]
    const [searchValue, setSearchValue] = useState("")
    const [selected, setSelected] = useState(null)
    const [sort, setSort] = useState(sortList[0])
    const [filters, setFilters] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [priceRange, setPriceRange] = useState({ min: 0, max: 50 })
    const itemsPerPage = 12
    const [showFilters, setShowFilters] = useState(false)


    const history = useHistory()
    const getType = () => {
        let type;
        switch (selectedOrderType) {
            case "delivery":
                type = "DeliverybyConsumerDriver";
                break;
            case "table":
                type = "DineIn";
                break;
            case "collection":
                type = "TakeAway";
                break;
            default:
                type = "DeliverybyConsumerDriver";
                break;
        }

        return type;
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleData = () => {
        setIsLoading(true)
        if (selected) {
            let menuIds = selected.MenuEntities?.map(entity => entity.ID)
            const promotionalItems = data.filter(item =>
                menuIds.includes(item.MenuItemID)
            );
            if (searchValue === "") {
                setItemsData(promotionalItems)
                setMenuData(promotionalItems.slice(0, 12))
                setTotalItems(promotionalItems.length)
            } else {
                const searchedItems = promotionalItems.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 12))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)
            setIsLoading(false)

        } else {
            if (searchValue === "") {
                setItemsData(data)
                setMenuData(data.slice(0, 12))
                setTotalItems(data.length)
            } else {
                const searchedItems = data.filter(item =>
                    item.Title.en.toLowerCase().includes(searchValue.toLowerCase())
                );
                setItemsData(searchedItems)
                setMenuData(searchedItems.slice(0, 12))
                setTotalItems(searchedItems.length)
            }
            setCurrentPage(1)
            setIsLoading(false)

        }
    }
    useEffect(() => {
        handleData()
    }, [selected, searchValue])

    useEffect(() => {
        if (filters.length > 0 || sort.value !== "popular" || (priceRange.min !== 0 && priceRange.max !== 50)) {
            fetchData()
        } else {
            handleData()
        }
    }, [sort, priceRange, filters, searchValue])
    const fetchData = async () => {
        const val = await getLocalStorageData(LOCAL_STORAGE_ITEMS_NAMES.ECOM_CART_DATA);
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID) ?? "";
        const countObj = {
            CloudLocationID: val.cloudLocationID,
            OrganizationID: val.organizationID,
            CategoryID: selected?.MenuCategoryID || "",
            UserID:
                localStorage.getItem("isLogged") === "true" ? userId : "",
            SearchTerm: searchValue?.toLowerCase() || "",
            SortBy: sort?.value || "",
            PriceMin: priceRange.min * 100,
            PriceMax: priceRange.max * 100,
            IsHalal: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Halal") ?? false,
            IsGlutenFree: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Gluten-Free") ?? false,
            IsVegetarian: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Vegetarian") ?? false,
            IsSpicy: filters.filter((fil) => fil.type === "DIET").some((it) => it.name === "Spicy") ?? false,
            FullFilmentType: getType(),
            PageNumber: currentPage,
            ItemsPerPage: itemsPerPage,
        };

        try {
            setIsLoading(true)

            let responsse = await getFilteredData(countObj)
            if (responsse) {
                setMenuData(responsse.data.Items)
                setTotalItems(responsse.total)
                setIsLoading(false)
            } else {
                setMenuData([])
                setTotalItems(0)
                setIsLoading(false)

            }

        } catch (error) {
            console.error("Error fetching data:", error);
            setMenuData([])
            setTotalItems(0)
            setIsLoading(false)
        }
    };
    return (
        <div className="RecommendedPage">
            <div className="header-contentcontainer ">
                <div className="heder-text-cont">
                    <img alt="" src={arrow} className="back-arr"
                        onClick={() => {
                            history.push("/")
                        }} />
                    <div className="header-txt">Recommended For You</div>
                </div>
                <div className="header-righ-search-filter-cont">
                    <div className="search-container-re">
                        <img alt="" src={search} className="seacrh-ico" />
                        <input
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value)
                            }}
                            placeholder="Search recommended items..." />
                        {searchValue !== "" && <img alt="" src={close} className="close-ico" onClick={() => {
                            setSearchValue("")
                        }} />}

                    </div>
                    <div className="filter-btn-vi" onClick={() => {
                        setShowFilters(!showFilters)
                    }}>
                        <img alt="" src={filter} className="filter-ico" />
                        Filter
                        {filters.length > 0 && <div className="filter-lngth">{filters.length}</div>}
                    </div>
                </div>
            </div>
            <CategoryLayoutList
                data={categories}
                selected={selected}
                setSelected={setSelected}
            />
            {showFilters && <FilterComponent
                filters={filters}
                setFilters={setFilters}
                sort={sort}
                setSort={setSort}
                rangeValue={{
                    Min: 0,
                    Max: 50
                }}
                sortList={sortList}
                setSelected={setSelected}
                setPriceRange={setPriceRange}
                priceRange={priceRange}
            />}
            <div className="rec-sort-items-con">
                <div className="rec-items-count">Showing <b>{totalItems}</b> recommended item(s)</div>
                <CustomDropdown items={sortList} selected={sort}
                    setSelected={setSort} />
            </div>
            {isLoading ?
                <div className="loader-cont">
                    <div className="loader-lay" /></div>
                :
                menuData.length > 0 ? <div className="items-layout">
                    <LayoutTemplate layout={"layout4"} items={
                        menuData || []
                    }
                        showHeader={false}
                        from="ALL"
                        setItems={setMenuData}
                        currentPage={currentPage + 1}
                        setTempData={setItemsData}
                        setAllData={setData}
                    />

                    {totalItems > 12 &&
                        <div className="pagination-container">
                            <Pagination
                                totalItems={totalItems}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                onPageChange={(e) => {
                                    setCurrentPage(e)
                                    setMenuData(itemsData?.slice(12 * (e - 1), 12 * e) || []);
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                }}
                            />
                        </div>}

                </div> :
                    <div className="rec-empty">
                        <img alt="" src={search} className="empty-searc-ic" />
                        <div className="empt-hdr">No items found</div>
                        <div className="empt-sub-hdr">We couldn't find any items matching your search criteria. Try adjusting your filters or search terms.</div>
                        <div className="empt-rst-btn"
                            onClick={() => {
                                setFilters([])
                                setCurrentPage(1);
                                setSelected(null)
                                setSearchValue("")
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }}>
                            <img alt="" src={redo} className="rest-ico" />
                            Reset All Filters</div>
                    </div>}
            {/* <LayoutTemplate layout={"layout4"} items={
                data.slice(52, 56) || []
            } showHeader
                headerText={"You Might Also Like"}
                onClick={() => {
                }} /> */}
        </div >
    )
}
export default RecommendedPage